import * as types from "./actionTypes";

export function throwException(exception, redirectToExceptionPage = false) {
	return {
		type: types.THROW_EXCEPTION,
		body: {
			exception,
			redirectToExceptionPage
		}
	};
}

export function clearException() {
	return {
		type: types.CLEAR_EXCEPTION
	};
}
